import { Machine } from '@internal/utils/machine/Machine';
import {
    ProductCard,
    ProductServiceCard,
} from '@renderer-ui-library/molecules';
import { Grid } from '@renderer-ui-library/mui';
import React from 'react';
import { Service } from './ISearchResultsBlockData';

export type SearchResultsListEntry =
    | { type: 'machine'; machine: Machine }
    | { type: 'service'; service: Service };

type Props = {
    entries: SearchResultsListEntry[];
};

export const ResultsList: React.FC<Props> = React.memo(props => (
    <>
        {props.entries.map((entry, index) => (
            <Grid
                key={
                    entry.type === 'machine'
                        ? entry.machine.machineGroupId
                        : `service-${index}-${entry.service.serviceType}-${entry.service.title}`
                }
                item
                xs={12}
                md={6}
                lg={4}
            >
                {entry.type === 'machine' && (
                    <ProductCard machine={entry.machine} />
                )}
                {entry.type === 'service' && (
                    <ProductServiceCard service={entry.service} />
                )}
            </Grid>
        ))}
    </>
));

ResultsList.displayName = 'ResultsList';
